import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import CoreuiVue from '@coreui/vue'
import CIcon from '@coreui/icons-vue'
import { iconsSet as icons } from '@/assets/icons'
import axios from 'axios'
import iStoreSetting from '@/scripts/istore-setting'
import iStoreUtils from '@/scripts/istore-utils'
import iStoreLocalData from '@/scripts/istore-local-data'
import iStoreUILang from '@/scripts/istore-ui-lang.js'
import Lifecycle from '@/scripts/lifecycle-plugin'
import { langControl } from '@/scripts/istore-ui-lang.js'
import VueDirective from '@/scripts/vue-directive'
import AlertConfirmModal from '@/components/AlertConfirmModal.vue'
import ImportExportModal from '@/components/ImportExportModal.vue'
import DOMPurify from 'dompurify'

// Vuetify
import 'vuetify/styles'
import {createVuetify} from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
// https://materialdesignicons.com/
import '@mdi/font/scss/materialdesignicons.scss'

const vuetify = createVuetify({
  components,
  directives,
})

const loadSetting = async () => {
  try {
    if (location.search.includes('dev=Y') || 'Y' === sessionStorage.getItem('debug')) {
      // For TEST URL Command
      iStoreSetting.debug = true
      let iStoreUrl = iStoreUtils.getUrlParam('iStoreUrl')
      let iStoreSTT = iStoreUtils.getUrlParam('iStoreSTT')
      if (iStoreUrl) {
        iStoreSetting.iStoreUrl = iStoreUrl
      }
      if (iStoreSTT) {
        const protocol = window.location.protocol
        const hostname = window.location.hostname
        const port = window.location.port
        iStoreSetting.iStoreSTT = port !== "" ? `${protocol}//${hostname}:${port}/sttqueue` : `${protocol}//${hostname}/sttqueue`;
      }
    }

    // Default
    if (!iStoreSetting.debug && location.hostname !== 'localhost') {
      if (location.port) {
        iStoreSetting.iStoreUrl = `${window.location.protocol}//${location.hostname}:${location.port}${process.env.VUE_APP_ISTORE_BASE}`
        iStoreSetting.iStoreSTT = `${window.location.protocol}//${location.hostname}:${location.port}${process.env.VUE_APP_STTQUEUE_BASE}`
      } else {
        iStoreSetting.iStoreUrl = `${window.location.protocol}//${location.hostname}${process.env.VUE_APP_ISTORE_BASE}`
        iStoreSetting.iStoreSTT = `${window.location.protocol}//${location.hostname}${process.env.VUE_APP_STTQUEUE_BASE}`
      }
    }

    const result = await axios.get('config/setting.json?_t=' + Date.now())
    if (result && result.data) {
      for (let key of Object.keys(result.data)) {
        iStoreSetting[key] = result.data[key]
      }
    }
  } catch (error) {
    //
    console.error(error)
  }
}

export const loadLanguage = async () => {
  await langControl.init()
}

const loadVueApp = async () => {
  const app = createApp(App)
  app.use(store)
  app.use(router)
  app.use(vuetify)
  app.use(CoreuiVue)
  app.use(iStoreUILang)
  if (iStoreSetting.debug) {
    app.use(Lifecycle)
  }
  VueDirective(app)
  app.provide('icons', icons)
  app.component('CIcon', CIcon)
  app.component('AlertConfirmModal', AlertConfirmModal)
  app.component('ImportExportModal', ImportExportModal)
  app.config.globalProperties.$sanitize = (html) => DOMPurify.sanitize(html)
  app.mount('#app')
}

;(async () => {
  iStoreLocalData.init()
  await loadSetting()
  await loadLanguage()
  await loadVueApp()
})()

// CSidebar.ts getComputedStyle not found ??
if (!window.getComputedStyle) {
  window.getComputedStyle = () => {
    //alert(1)
    return false;
  }
}
